import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

/**
 * One of the person's own page settings (saved on the server, so it follows them on every device). Returns the value
 * (or the default until loaded / when never set) and a setter; `set(null)` goes back to the default.
 */
export function usePref<T>(key: string, fallback: T): [T, (v: T | null) => void, boolean] {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ['pref', key], queryFn: () => api<{ value: T | null }>(`/api/me/prefs/${key}`).then((r) => r.value), staleTime: 5 * 60_000 });
  const save = useMutation({
    mutationFn: (value: T | null) => api(`/api/me/prefs/${key}`, { method: 'PUT', body: { value } }),
    onMutate: (value) => qc.setQueryData(['pref', key], value),
    onError: () => void qc.invalidateQueries({ queryKey: ['pref', key] }),
  });
  return [(q.data ?? fallback) as T, (v) => save.mutate(v), q.isSuccess];
}
